"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Link = _interopRequireDefault(require("../Link/Link"));
var BreadCrumbs = function BreadCrumbs(_ref) {
  var items = _ref.items;
  if (!items) return null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-c-breadcrumbs margin-bottom-sm"
  }, items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, item.link ? /*#__PURE__*/_react["default"].createElement("span", {
      key: JSON.stringify(item)
    }, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      href: item.link
    }, item.text)) : /*#__PURE__*/_react["default"].createElement("span", {
      key: JSON.stringify(item)
    }, item.text));
  }));
};
BreadCrumbs.propTypes = {
  items: _propTypes["default"].array
};
var _default = exports["default"] = BreadCrumbs;